import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState } from 'react';
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";
import LectureListOneDayArea from "@/pages/comp/edu/lecture/view_time_table/common/list_one_day";
import ViewOneWeekOfStuArea from "@/pages/comp/edu/lecture/view_time_table/common/one_week_of_stu";
import LectureListArea from "@/pages/comp/edu/lecture/common/list";

function LectureListOneDay2() {
  const show_tab_arr = [
    { text: "시간표", value: "one_day" },
    { text: "시간표(학생)", value: "one_week_of_stu" },
    { text: "시간표관리", value: "lecture_list" },
  ];
  const [show_tab, set_show_tab] = useState("one_day");
  
  return (
    <CompLayout isConTitle={false}>
      <div className="text-right">
        <div style={{display: "inline-block", width: "250px"}}>
          <SelectBoxBar
            valueTextArr={show_tab_arr}
            value={show_tab}
            name="show_tab"
            on_change={(inData: any) => {
              set_show_tab(inData.value);
            }}
            is_same_value_empty={false}
          ></SelectBoxBar>
        </div>
      </div>
      {show_tab == "one_day" &&
        <LectureListOneDayArea></LectureListOneDayArea>
      }
      {show_tab == "one_week_of_stu" &&
        <ViewOneWeekOfStuArea></ViewOneWeekOfStuArea>
      }
      {show_tab == "lecture_list" &&
        <LectureListArea></LectureListArea>
      }
    </CompLayout>
  );
}

export default LectureListOneDay2;